module.exports = __webpack_public_path__ + "static/media/financingIco.a2b0cd77.svg";